export const ChainActionTypes = {
  chainUpdate: 'ui/chain/update',
  chainReset: 'ui/chain/reset',
  chainRecordsCountUpdate: 'ui/chain/records-count/update',
  chainEditLock: 'ui/chain/edit-lock',
}
